/**
 * Table of Contents Generator
 * Automatically generates a table of contents from H2 headings on the page
 */

export default class TableOfContents {
    constructor() {
        this.container = document.querySelector('.table-of-contents');
        this.contentArea = document.querySelector('.text-content');

        if (this.container && this.contentArea) {
            this.init();
        }
    }

    init() {
        const headings = this.findH2Headings();

        if (headings.length > 0) {
            this.addIdsToHeadings(headings);
            this.generateTableOfContents(headings);
            this.addScrollBehavior();
        }
    }

    findH2Headings() {
        return Array.from(this.contentArea.querySelectorAll('h2'));
    }

    generateId(text) {
        return text
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim();
    }

    addIdsToHeadings(headings) {
        const usedIds = new Set();

        headings.forEach(heading => {
            let baseId = this.generateId(heading.textContent);
            let finalId = baseId;
            let counter = 1;

            while (usedIds.has(finalId)) {
                finalId = `${baseId}-${counter}`;
                counter++;
            }

            usedIds.add(finalId);
            heading.id = finalId;
        });
    }

    generateTableOfContents(headings) {
        const list = document.createElement('ul');
        list.className = 'toc-list space-y-2 hidden md:block';

        headings.forEach(heading => {
            const listItem = document.createElement('li');
            const link = document.createElement('a');

            link.href = `#${heading.id}`;
            link.textContent = heading.textContent;
            link.className = 'toc-link u-underline-animate text-green-500 hover:text-green-600 transition-colors duration-200 text-md leading-relaxed';

            listItem.appendChild(link);
            list.appendChild(listItem);
        });

        this.container.appendChild(list);
    }

    addScrollBehavior() {
        this.container.addEventListener('click', (e) => {
            const link = e.target.closest('.toc-link');
            if (link) {
                e.preventDefault();
                const targetId = link.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 80;

                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        });
    }
}